var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"kt_scrolltop",staticClass:"scrolltop",attrs:{"id":"kt_scrolltop"}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("fas fa-angle-up")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }